module.exports = __webpack_public_path__ + "static/media/persona-kenan.0ff076a7.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/persona-kenan.svg
// module id = 49
// module chunks = 0